import React, { useState } from 'react';
import Header from './Header';
import { useNavigate } from 'react-router-dom';
import arenaImg from './images/arena.jpeg';

function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simple hardcoded check for demonstration
    if (username === 'Admin' && password === 'password') {
      setError('');
      // Redirect to admin dashboard
      navigate('/admin-dashboard');
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `url(${arenaImg}) center center/cover no-repeat #f8f6f2`,
        backgroundAttachment: "fixed",
        width: "100vw", // Ensure full viewport width
        boxSizing: "border-box",
        overflowX: "hidden"
      }}
    >
      <form
        style={{
          background: "#fff",
          padding: "48px 32px",
          borderRadius: "16px",
          boxShadow: "0 8px 32px rgba(40,44,52,0.15)",
          minWidth: "320px",
          maxWidth: "380px",
          width: "90vw", // Responsive width for mobile
          maxWidth: "380px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          boxSizing: "border-box"
        }}
        onSubmit={handleSubmit}
      >
        <Header onBack={() => navigate(-1)} style={{ marginBottom: "20px" }} />
        <h2 style={{ marginBottom: 2, marginTop: "2px" }}>Admin Login</h2>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
          style={{
            marginBottom: 16,
            padding: "10px",
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "1rem"
          }}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          style={{
            marginBottom: 16,
            padding: "10px",
            width: "100%",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "1rem"
          }}
          required
        />
        {error && <div style={{ color: "red", marginBottom: 12 }}>{error}</div>}
        <button
          type="submit"
          style={{
            background: "#282c34",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "10px 22px",
            fontWeight: 700,
            fontSize: "1rem",
            cursor: "pointer"
          }}
        >
          Login
        </button>
      </form>
    </div>
  );
}

export default AdminLogin;